import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  choosePlanContainer: theme => ({
    borderTopWidth: 1,
    borderColor: theme.colors.borderColorSix,
    paddingHorizontal: 15.8,
    paddingBottom: 24.4,
  }),
  choosePlanButton: { marginTop: 24.4 },
  whyThisPlanContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 14,
  },
  whyThisPlanText: theme => ({
    fontSize: 16,
    marginRight: 8,
    color: theme.colors.text.primary,
  }),
  whyThisPlanIcon: {
    marginLeft: 5,
    marginBottom: 5,
  },
});
